export const Box = ({children = undefined as any | undefined}) => {
    return (
        <div className="has-background-grey-100 is-rounded-2">
            <div className="p-7">
                {children}
            </div>
        </div>
    )
}